module.exports = __webpack_public_path__ + "img/right-square.8e5db3c4.svg";